import {LiveBadge} from "../../Results/LiveBadge";
import React from "react";

type SportIconAndTitleProps = {
    imageUrl?: string;
    sportName?: string;
    color?: string;
    showLiveBadge: boolean;
}

export function SportIconAndTitle(props: SportIconAndTitleProps) {
    const {imageUrl, sportName, color, showLiveBadge} = props;

    return (
        <div className="flex items-center justify-between">
            <div style={{display: 'flex', alignItems: 'center'}} >
                <div style={{
                    width: 25,
                    height: 25,
                    backgroundColor: color,
                    WebkitMaskImage: `url(${imageUrl})`,
                    maskImage: `url(${imageUrl})`
                }} />
                <div style={{ marginLeft: 9, fontWeight: 500 }}>{sportName}</div>
            </div>
            {showLiveBadge && <LiveBadge/>}
        </div>
    )
}

interface ColoredIconProps  {
    color?: string;
    imageUrl?: string;
}

export const ColoredIcon = React.memo(({color, imageUrl}: ColoredIconProps) => {
    return (<div style={{
        width: 25,
        height: 25,
        backgroundColor: color,
        WebkitMaskImage: `url(${imageUrl})`,
        maskImage: `url(${imageUrl})`
    }} />)
}, (prevProps, nextProps) => {
    return prevProps.color === nextProps.color && prevProps.imageUrl === nextProps.imageUrl
});
